import { render } from "./SimpleSidebar.vue?vue&type=template&id=724fa042&scoped=true"
import script from "./SimpleSidebar.vue?vue&type=script&lang=js"
export * from "./SimpleSidebar.vue?vue&type=script&lang=js"

import "./SimpleSidebar.vue?vue&type=style&index=0&id=724fa042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724fa042"]])

export default __exports__